<template>
    <div class="container-fluid">
        <div v-if="user" class="row">
            <div class="card col">
                <div class="card-header">
                    <h1>Portal Updates</h1>
                </div>
                <div class="card-body">
                    <ChangeLog></ChangeLog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mgr from '@/services/SecurityService'
    import ChangeLog from '@/components/general/ChangeLog.vue';
    export default {
        components: {
            ChangeLog
        },
        data() {
            return {
                mgr: new Mgr(),
                user: null,

            };
        },
        mounted() {
            this.mgr.getUser().then(
                data => {
                    this.user = data;
                },
                err => {
                    console.log(err)
                }
            );
        },
    }
</script>

<style>
</style>
